// Application: ECOM
// This file is for JS that is used on every (or almost every) page across the application

// Import the nav and footer scripts from frontend engine
//
// This is a duplication `main` manifest file from FE: `vt-frontend-engine/app/scripts/main`
// but importing the pieces individually in case the manifest is changed/removed
import 'vt-frontend-engine/app/scripts/components/footer-accordion.js';
import 'vt-frontend-engine/app/scripts/components/footer-collapsible.js';
import 'vt-frontend-engine/app/scripts/components/nav-search.js';
import 'vt-frontend-engine/app/scripts/components/site-nav.js';
import 'vt-frontend-engine/app/scripts/components/top-bar.js';



// WEBPACK FOOTER //
// ./client/app/scripts/application/ecom.js